import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { ContextService } from '@apply4u/services/context-service';
import { IsTrue } from '@apply4u/shared/helpers/common/type-safe-helpers';

@Injectable({
  providedIn: 'root'
})
export class RecruiterRouteGuard  {

  constructor(
    private contextService: ContextService,
    private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (this.contextService.IsUserLoggedIn) {
      if (this.contextService.IsJobSeeker) {
        // when user is jobseeker and trying to access recruiter url
       // const _isRecruiter = this.localStorageService.GetItem(LoginTypeKeys.IsRecruiter);

        if (IsTrue(this.contextService.IsJobSeeker)) {
          this.router.navigateByUrl(this.contextService.RedirectUrl);
        } else {
          this.contextService.SetIsJobSeeker(false);
        }
      } 
    } else {
      this.contextService.SetIsJobSeeker(false);
    }

    return true;
  }

}
